/* eslint-disable react/no-unescaped-entities */
import logo_primary_astm_tagline from 'astm-ux-design-system/dist/assets/img/ASTM logo_primary_astm_tagline.png'
import React, { Suspense } from 'react'
import { Image } from 'react-bootstrap'
import HeaderSearchBox from 'shared-components/SearchBox'
import { cacheManager } from 'helpers/util-common'
import TopMenu from './TopMenu'
const WCMSHeader = React.lazy(()=>import("../../../src/shared-components/WCMS/WCMSHeader"));
const WCMSTopNavMenu = React.lazy(()=>import("../WCMS/WCMSTopNavMenu"));

const Header = (props) => {
	let featureFlag = cacheManager.getItem("flagFeature") ? JSON.parse(cacheManager.getItem("flagFeature") ): null;
	return (
    <header data-testid="headertest">
      <div className="container">
        {!featureFlag?.WcmsNavIntegration ? (
          <div className="headerWrap">
            <div className="logoWrap">
              <a
                href={`${process.env.REACT_APP_PUB_URL}`}
                target="_blank"
                rel="noreferrer"
              >
                <Image src={logo_primary_astm_tagline} alt="ASTM Logo" />
              </a>
            </div>
            <div className="headerFilterhWrap">
              <div className="searchWrap">
                <HeaderSearchBox featureFlag={featureFlag}/>
              </div>
            </div>
          </div>
        ) : (
          <Suspense>
            <WCMSHeader {...props} featureFlag={featureFlag}/>
          </Suspense>
        )}
      </div>
      {featureFlag?.WcmsNavIntegration ? (
        <Suspense>
          <WCMSTopNavMenu />
        </Suspense>
      ) : (
        <TopMenu {...props} />
      )}
    </header>
  );
}

export default Header
